import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import AudioTemplate from './AudioTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

export default class AudioComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.AUDIO)
    
    this.data.component = AudioTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder (node) {
    node.lingualName = lingualName.AUDIO
    this.setConnection()

    const audioInput = new Rete.Input(CONST_SOCKET.AUDIO_INPUT, lang.audio_socket_input_reply, this.socket.audioInput, true)
    const audioOutput = new Rete.Output(CONST_SOCKET.AUDIO_OUTPUT, lang.audio_socket_output_next, this.socket.audioOutput, false)
    const audioOutputQuickreply = new Rete.Output(CONST_SOCKET.AUDIO_OUTPUT_QUICKREPLY, lang.audio_socket_output_quick_replies, this.socket.audioOutputQuickreply, true)

    return node
      .addInput(audioInput)
      .addOutput(audioOutput)
      .addOutput(audioOutputQuickreply)
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.AUDIO_OUTPUT] = node.data
  }

  setConnection () {
    // Audio may be connected to:
    this.socket.audioOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.audioOutput.combineWith(this.socket.openaiInput)
    this.socket.audioOutput.combineWith(this.socket.carouselInput)
    this.socket.audioOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.audioOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.audioOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.audioOutput.combineWith(this.socket.videoInput)
      this.socket.audioOutput.combineWith(this.socket.audioInput)
      this.socket.audioOutput.combineWith(this.socket.fileInput)
      // this.socket.audioOutput.combineWith(this.socket.otnInput)
      if(this.isRcnAddonAvailable)
        this.socket.audioOutput.combineWith(this.socket.rcnInput)
    }
    
    this.socket.audioOutput.combineWith(this.socket.ecommerceInput)
    this.socket.audioOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.audioOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.audioOutput.combineWith(this.socket.httpApiInput)
    }
    

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.audioOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (QuickReply): QuickReply
    this.socket.audioOutputQuickreply.combineWith(this.socket.quickReplyInput)
  }
}